import LaborDashboardContainer from './containers/LaborDashboardContainer';

export default LaborDashboardContainer;
